import convertFormData from '@module/utils/convertFormData';

import { fetchExtended } from '../../../utils/fetch/client-fetch';
import type { PageListParams } from '../../type';
import type {
  EventHeartListParams,
  EventHeartListResponse,
  FetchBjLevelResponse,
  FetchHeartChargeListResponse,
  FetchHeartInfoParams,
  FetchHeartInfoResponse,
  FetchHeartSumListResponse,
  FetchHeartUseListResponse,
  HoldHeartDetailListParams,
  HoldHeartDetailListResponse,
  HoldHeartListParams,
  HoldHeartListResponse,
  UserGiftListParams,
  UserGiftListResponse,
  UserGiftStatParams,
  UserGiftStatResponse,
} from './type';

export const fetchHeartInfo = async (heartInfoParams?: FetchHeartInfoParams) => {
  const fetchOptions: RequestInit = {
    method: 'POST',
    credentials: 'include',
    ...(heartInfoParams && { body: convertFormData(heartInfoParams) }),
  };

  const res = await fetchExtended(`/v1/heart/index`, fetchOptions);

  const result = await res.json();

  return result as FetchHeartInfoResponse;
};

export const fetchHeartUseList = async (heartUseListParams: PageListParams) => {
  const res = await fetchExtended(`/v1/heart/use_list`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(heartUseListParams),
  });

  const result = await res.json();

  return result as FetchHeartUseListResponse;
};

export const fetchHeartChargeList = async (heartChargeListParams: PageListParams) => {
  const res = await fetchExtended(`/v1/heart/charge_list`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(heartChargeListParams),
  });

  const result = await res.json();

  return result as FetchHeartChargeListResponse;
};

export const fetchHeartSumList = async (heartSumListParams: PageListParams) => {
  const res = await fetchExtended(`/v1/heart/sum_list`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(heartSumListParams),
  });

  const result = await res.json();

  return result as FetchHeartSumListResponse;
};

export const fetchHeartFreeList = async (heartFreeListParams: PageListParams) => {
  const res = await fetchExtended(`/v1/heart/free_coin_list`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(heartFreeListParams),
  });

  const result = await res.json();

  return result as FetchHeartChargeListResponse;
};

export const fetchBjLevel = async (bjLevelParams: FetchHeartInfoParams) => {
  const res = await fetchExtended(`/v1/heart/bj_level`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(bjLevelParams),
  });

  const result = await res.json();

  return result as FetchBjLevelResponse;
};

export const fetchUserGiftChartData = async (userGiftStatParams: UserGiftStatParams) => {
  const res = await fetchExtended(`/v1/heart/user_gift_stat`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(userGiftStatParams),
  });

  const result = await res.json();

  return result as UserGiftStatResponse;
};

export const fetchUserGiftList = async (userGiftListParams: UserGiftListParams) => {
  const res = await fetchExtended(`/v1/heart/user_gift_list`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(userGiftListParams),
  });

  const result = await res.json();

  return result as UserGiftListResponse;
};

export const fetchEventHeartList = async (eventHeartListParams: EventHeartListParams) => {
  const res = await fetchExtended(`/v1/heart/event_list`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(eventHeartListParams),
  });

  const result = await res.json();

  return result as EventHeartListResponse;
};

export const fetchHoldHeartList = async (holdHeartListParams: HoldHeartListParams) => {
  const res = await fetchExtended(`/v1/heart/hold_list`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(holdHeartListParams),
  });

  const result = await res.json();

  return result as HoldHeartListResponse;
};

export const fetchHoldHeartDetailList = async (holdHeartDetailListParams: HoldHeartDetailListParams) => {
  const res = await fetchExtended(`/v1/heart/hold_list_detail`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(holdHeartDetailListParams),
  });

  const result = await res.json();

  return result as HoldHeartDetailListResponse;
};
